import { Notification } from './../models/notification';
import { ConfigData } from 'app/app.config';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class NotificationsCenterService {
    constructor(private httpClient: HttpClient) { }

    public getNotifications(): Observable<Notification[]> {
        return this.httpClient.get<Notification[]>(`${ConfigData.apiUrl}/notification`);
    }

    public markNotificationRead(notification: Notification): Observable<any> {
        return this.httpClient.put<Notification>(`${ConfigData.apiUrl}/notification/${notification.idNotification}`, {});
    }
}